// custom.js


// Codigo para poner la descripcion despues del boton añadir carrito en la pagina de producto predeterminado
document.addEventListener('DOMContentLoaded', function() {
  // Mover la descripción DESPUÉS del formulario de producto
  const productTab = document.querySelector('.productView-tab');
  const productForm = document.querySelector('.productView-form');
  
  if (productTab && productForm) {
    // insertAfter: inserta productTab después de productForm
    productForm.parentNode.insertBefore(productTab, productForm.nextSibling);
  }
});


// Codigo para poner el placeholder del filtro de precio a "0"
document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector('input#Filter-Max-Precio-2');
  if (input) {
    input.placeholder = "0";
  }
});

